import { patch, post, read } from '@/utils/request';
import type { ListData, LogInfo, ObjectMap, SimpleFunc } from 'bv-typings';
import type { IPolicySight } from '@/services/policyInsight/interface';
import type { OeTokenAPI } from '@/services/administration/oeToken/typings';
import { getAccountProcessListParams, type PromotableUrlRisk } from './totalAccount';

export enum BlackWhiteType {
  WHITE = 'white',
  BLACK = 'black',
}
export type IAeReviewAccountInfo = {
  aeNote?: string; // ae备注
  aeAppendInfoTime: string; // 补充开户信息时间
  addressZh: string; // 公司地址（中）
  businessRegistrationId: string; // 统一社会信用代码
  businessRegistrationIdChecked: number; // 统一社会信用代码核对结果
  // [  '未处理','成功', '失败']
  businessRegistrationAddrChecked: number; // 公司地址（中）核对结果
  businessRegistrationEntityChecked: number; // 营业执照与结算主体核对结果
  businessManagerId: string; // 代理商BM ID
  businessRegistration: string; // 营业执照
  bmHandleStatus: string; // bm名称获取状态
  bmName: string; // BM名称
  customerInfoComplete: string; // 信息调研完成
  disapprovalReasonsBf: string; // 驳回原因
  entityNameEn: string; // 开户主体（En）
  entityNameZh: string; // 开户主体
  id: string; // 主ID
  number: number; // 开户数量
  officialWebsiteUrl: string;
  paymentName: string | null; // 结算主体
  paymentInfo: string; // 支付信息
  promotableUrls: string[]; // 粉丝页
  promotableAppIds: string[]; // 推广App Ids
  promotablePageIds: string[];
  oeRequestId: string;
  requestId: string;
  registrationCheckStatus: string; // 营业执照核对状态
  sale?: number; // 销售ID
  saleName?: string; // 销售名称
  status: number; // 状态
  subvertical: string; // 子业务类型
  spendCap: string; // 额度
  tokenId: string; // 开户Token
  userId: number; // 提交人ID
  userName: string; // 提交人
  vertical: string; // 开户类型
  onSuccess?: SimpleFunc;
  adAccountNumber?: number;
  openAccountLimitType: number[]; // 开户主体限制类型
  openAccountLimitReason: string; // 开户主体限制原因
  settlementLimitType: number[]; // 结算主体限制类型
  settlementLimitReason: string; // 结算主体限制原因
  larr: number;
  drr: number;
  signal: IPolicySight.Common.PolicyContent;
  logInfo: LogInfo[];

  auditModelType: BlackWhiteType;
  tokenAttr: OeTokenAPI.Common.TokenTypeEnum; // Token属性 专属/公共
} & PromotableUrlRisk;

const getReviewList = async () => {
  const params = getAccountProcessListParams();
  const { isConfirm, openAccountLimitType } = params;
  
  const newParams = {
    ...params,
    isConfirm: isConfirm ? Number(isConfirm) : undefined,
    openAccountLimitType: openAccountLimitType ? Number(openAccountLimitType) : undefined,
    promotableUrls: Array.isArray(params?.promotableUrls)
      ? params?.promotableUrls?.map((item: string) => btoa(item))?.join(',')
      : params?.promotableUrls
      ? btoa(params?.promotableUrls)
      : undefined,
  };
  delete newParams.product_tag23;

  return read<ListData<IAeReviewAccountInfo>>('account_opening_review/aor', newParams);
};

const getReviewDetail = async (id: string) => {
  return read<ListData<IAeReviewAccountInfo>>(
    'account_opening_review/aor',
    undefined,
    '获取详情失败',
    id,
  );
};

export type IBatchParams = {
  ids: string[];
};

const batchReject = async (params: IBatchParams) =>
  post('account_opening_review/aor_reject', params, '批量操作失败');

const batchApprove = async (params: IBatchParams) =>
  post('account_opening_review/aor_approve', params, '批量操作失败');

const batchSupplementInfo = async (params: ObjectMap[]) => {
  return patch('account_opening_review/aor', params, '批量操作失败');
};

const batchManualApprove = async (params: IBatchParams) =>
  post('account_opening_review/aor_manual_check', params, '人工校验失败');

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const supplementInfo = async (params: any, requestId?: string) => {
  return patch('account_opening_review/aor', params, '补充信息失败', requestId);
};

const getVerticalList = async () => {
  return read<ObjectMap<string[]>>(
    'account_opening_review/get_vertical',
    undefined,
    undefined,
    undefined,
    { isCamel: false },
  );
};

const getVertical = async () => {
  const [res] = await getVerticalList();
  return Object.keys(res ?? {}).map((item) => ({ title: item, value: item }));
};

const getSubvertical = async (vertical: string) => {
  const [res] = await getVerticalList();
  return res?.[vertical].map((item) => ({ title: item, value: item }));
};

export {
  getReviewList,
  getReviewDetail,
  batchReject,
  batchApprove,
  batchSupplementInfo,
  supplementInfo,
  getVerticalList,
  getVertical,
  getSubvertical,
  batchManualApprove,
};
